(function () {
  const ROUND_TO = 5;

  const PRICE_SELECTORS = [
    '.money',
    '[class*="money"]',
    '[class*="price"]',
    '[data-bucks]',
    '[class*="bucks"]',
  ];

  const CURRENCY_SYMBOLS = ['$', '€', '£'];

  function roundUpToNearest(value, nearest) {
    return Math.ceil(value / nearest) * nearest;
  }

  function hasCurrencySymbol(text) {
    return CURRENCY_SYMBOLS.some((symbol) => text.includes(symbol));
  }

  function extractNumber(text) {
    const match = text.match(/(\d+(?:[.,]\d+)?)/);

    if (!match) {
      return null;
    }

    return Number(match[1].replace(',', '.'));
  }

  function getCurrencySymbol(text) {
    return CURRENCY_SYMBOLS.find((symbol) => text.includes(symbol)) || '';
  }

  function shouldSkipElement(element) {
    const text = element.textContent.trim();

    if (!text) {
      return true;
    }

    if (element.dataset.customRounded === 'true') {
      return true;
    }

    if (!hasCurrencySymbol(text)) {
      return true;
    }

    const number = extractNumber(text);

    if (!number) {
      return true;
    }

    return false;
  }

  function roundPriceElement(element) {
    if (shouldSkipElement(element)) {
      return;
    }

    const originalText = element.textContent.trim();
    const symbol = getCurrencySymbol(originalText);
    const number = extractNumber(originalText);

    if (!symbol || !number) {
      return;
    }

    const roundedNumber = roundUpToNearest(number, ROUND_TO);

    element.textContent = `${symbol}${roundedNumber}`;
    element.dataset.customRounded = 'true';
  }

  function roundAllPrices() {
    PRICE_SELECTORS.forEach((selector) => {
      document.querySelectorAll(selector).forEach(roundPriceElement);
    });
  }

  function resetRoundedFlags() {
    document.querySelectorAll('[data-custom-rounded="true"]').forEach((element) => {
      element.removeAttribute('data-custom-rounded');
    });
  }

  function run() {
    resetRoundedFlags();
    roundAllPrices();
  }

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(run, 800);
    setTimeout(run, 1500);
    setTimeout(run, 3000);
  });

  document.addEventListener('change', function () {
    setTimeout(run, 800);
  });

  document.addEventListener('click', function () {
    setTimeout(run, 800);
  });

  const observer = new MutationObserver(function () {
    clearTimeout(window.__customCurrencyRoundingTimer);

    window.__customCurrencyRoundingTimer = setTimeout(run, 300);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();